<template>
    <div>
    <div class="d-flex flex-column-fluid">
        <!--begin::Container-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-lg-12 col-xl-12">
                            <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                                <div class="card-header align-items-center border-bottom-dark px-0">
                                    <div class="card-title mb-0">
                                        <h3 class="card-label mb-0 font-weight-bold text-body">
                                            Заказ <span class="text-black-50">#{{ orders.order_id }} {{(orders.opencart_id)?'('+orders.opencart_id+')':'' }}</span>
                                        </h3>
                                    </div>
                                    <div class="actions">
                                        <button
                                            class="btn ml-2 p-0 d-none"
                                            @click="showActivityLog"
                                            data-toggle="tooltip"
                                            title="История изменений"
                                            data-placement="left">
                                            <span class="h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center rounded-circle shadow-sm">
                                                <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-clock-history" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"/>
                                                    <path fill-rule="evenodd" d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"/>
                                                    <path fill-rule="evenodd" d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"/>
                                                </svg>
                                            </span>
                                        </button>
                                        <button v-if="orders.shipping_method_detail && orders.shipping_method_detail.shipping_method_id == 2" @click="generateOmniva()"  class="btn btn-dark">Генерировать Omniva</button>
                                        <button v-if="orders.shipping_method_detail && orders.shipping_method_detail.shipping_method_id == 2 && orders.tracking" @click="downloadOmnivaLabel()"  class="btn btn-dark">Label Omniva</button>
                                        <!-- On dropshipping the label is the
                                             partner's own upload: there is no
                                             carrier to generate one and no
                                             tracking number to wait for. -->
                                        <!-- The method is checked here too, not
                                             only the file: an order switched to
                                             a courier after the upload keeps the
                                             file, and the button would have
                                             served the courier's label. -->
                                        <button v-if="orders.dropship_label && orders.shipping_method_detail && orders.shipping_method_detail.shipping_methods_type_link == 'b2b_dropship'" @click="downloadPartnerLabel()" class="btn btn-dark">Наклейка партнёра</button>
                                        <button @click="downloadInvoice()"  class="btn btn-dark">Скачать накладную</button>
                                        <button @click="downloadBill()"  class="btn btn-dark">Скачать счет фактура</button>
                                        <button @click="downloadPackingList()"  class="btn btn-dark">Скачать Packing List</button>
                                        <button @click="generateCMR()"  class="btn btn-dark">Сгенерировать CMR</button>
                                        <router-link :to="`/admin/order/${$route.params.id}/edit`">
                                            <button v-if="!processed && !editMode" @click="editOrder()"  class="btn btn-primary">Изменить</button>
                                        </router-link>
                                        <button
                                            type="button"
                                            class="btn"
                                            :class="[{'btn-dark': !processed}, {'btn-danger': processed}]"
                                            @click="switchProcess(false)"
                                        >
                                            {{ processed ? 'Отменить проводку' : 'Провести' }}
                                        </button>
                                    </div>

                                </div>
                                <div class="card-body pb-0 pt-4 d-none">
                                    <div class="d-flex justify-content-center">
                                        <ul class="nav nav-pills mb-0" id="pills-tab" role="tablist">
                                            <li class="nav-item">
                                                <a
                                                    class="nav-link active"
                                                    id="detail-tab"
                                                    data-toggle="pill"
                                                    href="#detail"
                                                    role="tab"
                                                    aria-controls="detail"
                                                    aria-selected="true"
                                                >
                                                    <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-file-earmark-text" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M4 0h5.5v1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h1V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"
                                                        />
                                                        <path d="M9.5 3V0L14 4.5h-3A1.5 1.5 0 0 1 9.5 3z" />
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M5 11.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"
                                                        />
                                                    </svg>
                                                    Detail</a
                                                >
                                            </li>
                                            <li class="nav-item">
                                                <a
                                                    class="nav-link"
                                                    id="invoice-tab"
                                                    data-toggle="pill"
                                                    href="#invoice"
                                                    role="tab"
                                                    aria-controls="invoice"
                                                    aria-selected="false"
                                                >
                                                    <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-receipt" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27zm.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0l-.509-.51z"
                                                        />
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"
                                                        />
                                                    </svg>
                                                    Invoice
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a
                                                    class="nav-link"
                                                    id="status-tab"
                                                    data-toggle="pill"
                                                    href="#status"
                                                    role="tab"
                                                    aria-controls="status"
                                                    aria-selected="false"
                                                >
                                                    <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-check2-square" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M15.354 2.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L8 9.293l6.646-6.647a.5.5 0 0 1 .708 0z"
                                                        />
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M1.5 13A1.5 1.5 0 0 0 3 14.5h10a1.5 1.5 0 0 0 1.5-1.5V8a.5.5 0 0 0-1 0v5a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 0 0-1H3A1.5 1.5 0 0 0 1.5 3v10z"
                                                        />
                                                    </svg>
                                                    Status
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a
                                                    class="nav-link"
                                                    id="notes-tab"
                                                    data-toggle="pill"
                                                    href="#notes"
                                                    role="tab"
                                                    aria-controls="notes"
                                                    aria-selected="false"
                                                >
                                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-clock-notes" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"
                                                        />
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"
                                                        />
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"
                                                        />
                                                    </svg>
                                                    Notes
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a
                                                    class="nav-link"
                                                    id="message-tab"
                                                    data-toggle="pill"
                                                    href="#message"
                                                    role="tab"
                                                    aria-controls="message"
                                                    aria-selected="false"
                                                >
                                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-clock-notes" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"
                                                        />
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"
                                                        />
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"
                                                        />
                                                    </svg>
                                                    Message
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-xl-12">
                            <div class="tab-content" id="pills-tabContent">
                                <div class="tab-pane fade show active" id="detail" role="tabpanel" aria-labelledby="detail-tab">
                                    <div class="card card-custom gutter-b bg-white border-0">

                                        <div class="card-body pt-0">
                                            <div class="row gutter-pb gutter-pt border-bottom order-payment justify-content-center">
                                                <div class="col-12 col-lg-4 col-xl-4 payment-detail">
                                                    <h4 class="card-label mb-2 font-weight-bold font-size-h4 text-body">
                                                        Общие данные
                                                    </h4>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Метод оплаты:

                                                        <span v-if="orders.payment_method == 'cod'" class="text-dark font-size-base">Uz vietas</span>
                                                        <span v-if="orders.payment_method == 'banktransfer'" class="text-dark font-size-base">Bankas parskaitījums</span>
                                                        <span v-if="orders.payment_method == 'online'" class="text-dark font-size-base">Ar karti</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Метод доставки:
                                                        <span v-if="orders.shipping_method_detail && orders.shipping_method_detail.shipping_methods_type_link == 'courier_dpd'" class="text-dark font-size-base">DPD</span>
                                                        <span v-if="orders.shipping_method_detail && orders.shipping_method_detail.shipping_methods_type_link == 'pakomats_omniva'" class="text-dark font-size-base">Omniva</span>
                                                        <span v-if="orders.shipping_method_detail && orders.shipping_method_detail.shipping_methods_type_link == 'localpickup'" class="text-dark font-size-base">Pašiznemšana</span>
                                                    </h5>
                                                    <h5 v-if="orders.shipping_option_detail" class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Пакомат:
                                                        <span class="text-dark font-size-base">{{orders.shipping_option_detail.shipping_option_link }}</span>
                                                    </h5>
                                                    <h5 v-if="orders.shipping_method_detail && orders.shipping_method_detail.shipping_method_id == 2 && orders.tracking" class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Tracking number:
                                                        <span class="text-dark font-size-base">{{orders.tracking }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body d-none">
                                                        Transaction ID:
                                                        <span class="text-dark font-size-base">{{ orders.transaction_id ? orders.transaction_id : "none" }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Сумма:
                                                        <span class="text-dark font-size-base">{{orders.order_price }} €</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Дата:
                                                        <span class="text-dark font-size-base">{{orders.order_date_formatted }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Статус:
                                                        <select v-model="orders.order_status.id" class="js-states form-control bg-transparent">
                                                            <option
                                                                v-for="order_status in order_statuses"
                                                                    v-bind:value="order_status.order_status_id"
                                                            >
                                                                {{ getOrderStatusName(order_status) }}
                                                            </option>
                                                        </select>
                                                    </h5>

                                                    <h5 v-show="processed" class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Дата документа:
                                                        <fieldset class="form-group mb-3">
                                                            <input type="date" class="form-control bg-white" value=""  v-model="processed_at"/>
                                                            <small class="form-text text-danger"></small>
                                                        </fieldset>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Apmaksat lidz (Оплатить до):
                                                        <fieldset class="form-group mb-3">
                                                            <input type="date" class="form-control bg-white" v-model="orders.payment_due_date" @change="updatePaymentDueDate"/>
                                                            <small class="form-text text-muted" v-if="orders.payment_due_date">{{ orders.payment_due_date }}</small>
                                                        </fieldset>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Внутренний комментарий:
                                                        <span class="text-dark font-size-base">{{orders.internal_note }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Комментарий в счете:
                                                        <span class="text-dark font-size-base">{{orders.bill_note }}</span>
                                                    </h5>
                                                </div>
                                                <div class="col-12 col-lg-6 col-xl-4 payment-detail">
                                                    <h4 class="card-label mb-2 font-weight-bold font-size-h4 text-body">
                                                        Биллинг данные
                                                    </h4>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Имя:
                                                        <span class="text-dark font-size-base">{{orders.billing_first_name }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Фамилия:
                                                        <span class="text-dark font-size-base">{{orders.billing_last_name }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Эл.почта:
                                                        <span class="text-dark font-size-base">{{orders.customer.customer_email }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Адрес:
                                                        <span class="text-dark font-size-base">{{orders.billing_street_address }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Город:
                                                        <span class="text-dark font-size-base">{{orders.billing_city }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Страна:
                                                        <span class="text-dark font-size-base">{{(orders.billing_country1)?orders.billing_country1.country_name:''  }}</span>
                                                    </h5>
                                                    <!-- <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Край:
                                                        <span class="text-dark font-size-base">{{orders.billing_state1.name }}</span>
                                                    </h5> -->
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Почтовый код:
                                                        <span class="text-dark font-size-base">{{orders.billing_postcode }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Телефон:
                                                        <span class="text-dark font-size-base">{{orders.billing_phone }}</span>
                                                    </h5>
                                                </div>
                                                <div class="col-12 col-lg-6 col-xl-4 payment-detail">
                                                    <h4 class="card-label mb-2 font-weight-bold font-size-h4 text-body">
                                                        Данные доставки
                                                    </h4>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Имя:
                                                        <span class="text-dark font-size-base">{{orders.delivery_first_name }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Фамилия:
                                                        <span class="text-dark font-size-base">{{orders.delivery_last_name }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Эл.почта:
                                                        <span class="text-dark font-size-base">{{orders.customer.customer_email }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Адрес:
                                                        <span class="text-dark font-size-base">{{orders.delivery_street_address }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Город:
                                                        <span class="text-dark font-size-base">{{orders.delivery_city }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Страна:
                                                        <span class="text-dark font-size-base">{{(orders.delivery_country1)?orders.delivery_country1.country_name:'' }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Край:
                                                        <span class="text-dark font-size-base">{{(orders.delivery_state1)?orders.delivery_state1.name:'' }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Почтовый код:
                                                        <span class="text-dark font-size-base">{{orders.delivery_postcode }}</span>
                                                    </h5>
                                                    <h5 class="card-label mb-2 font-weight-bold font-size-h5 text-body">
                                                        Телефон:
                                                        <span class="text-dark font-size-base">{{orders.delivery_phone }}</span>
                                                    </h5>
                                                </div>
                                            </div>
                                            <div v-if="type !='offer'" class="row">
                                                <div class="col-12 gutter-pt table-padding" id="printableTable">
                                                    <table class="table table-striped text-body">
                                                        <thead>
                                                        <tr class="d-flex">
                                                            <th class="col-1">ID</th>
                                                            <th class="col-2">Продукт</th>
                                                            <th class="col-1">Остаток</th>
                                                            <th class="col-1">Код</th>
                                                            <th class="col-2">Цена</th>
                                                            <th class="col-2">Цена со скидкой</th>
                                                            <th class="col-1">Кол-во</th>
                                                            <th class="col-2">Сумма</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody id="order-show-detail">
                                                        <tr class="d-flex responsive-lay"
                                                            v-for="(detail, index) in orders.order_detail"
                                                            v-if="detail.product.product_type == 'variable'"
                                                        >
                                                            <td class="tag-color col-12 col-md-1">
                                                                {{ index + 1 }}
                                                            </td>
                                                            <td class="col-12 col-md-2 item-detail-left">
                                                                <div class="text-body">
                                                                    <h6 class="order-product-name">
                                                                        {{ detail.product.product_title }}
                                                                        <span v-if="detail.is_gift" class="badge badge-success ml-1">Подарок</span>
                                                                        <span
                                                                            v-for="variation in detail.product_combination.combination"
                                                                            :key="variation.variation_id"
                                                                        >
                                                                            {{ getVariationName(variation) }}
                                                                        </span>
                                                                    </h6>
                                                                </div>
                                                            </td>
                                                            <td class="tag-color col-12 col-md-1 order-price">
                                                                {{ 
                                                                    detail.product_combination && detail.product_combination.available_qty 
                                                                        ? detail.product_combination.available_qty 
                                                                        : (detail.product && detail.product.available_qty 
                                                                            ? detail.product.available_qty 
                                                                            : 0) 
                                                                }}
                                                            </td>
                                                            <td class="tag-color col-12 col-md-1 order-price">
                                                                {{ (detail.product.product_sku) ? detail.product.product_sku : detail.product.product_barcode }}
                                                            </td>
                                                            <td class="tag-color col-12 col-md-2 order-price">
                                                                {{ detail.product_price_with_tax }} €
                                                            </td>
                                                            <td class="tag-color col-12 col-md-2 order-price">
                                                                {{ (detail.product_discount_price_with_tax>0)?detail.product_discount_price_with_tax:detail.product_price_with_tax}} €
                                                            </td>
                                                            <td class="col-12 col-md-1">
                                                                <div class="input-group">
                                                                    {{ detail.product_qty }}
                                                                </div>
                                                            </td>
                                                            <td class="tag-s col-12 col-md-2 order-sub-price">
                                                                {{ parseFloat(detail.product_discount_price_with_tax*detail.product_qty).toFixed(2) }} €
                                                            </td>
                                                        </tr>

                                                        <tr class="d-flex responsive-lay"
                                                            v-for="(detail, index) in orders.order_detail"
                                                            v-if="detail.product.product_type == 'simple'"
                                                        >
                                                            <td class="tag-color col-12 col-md-1">
                                                                {{ index + 1 }}
                                                            </td>
                                                            <td class="col-12 col-md-2 item-detail-left">
                                                                <div class="text-body">
                                                                    <h6 class="order-product-name">
                                                                        {{ detail.product.product_title }}
                                                                        <span v-if="detail.is_gift" class="badge badge-success ml-1">Подарок</span>
                                                                    </h6>
                                                                </div>
                                                            </td>
                                                            <td class="tag-color col-12 col-md-1 order-price">
                                                                {{ (detail.product.available_qty)?detail.product.available_qty:0  }}
                                                            </td>
                                                            <td class="tag-color col-12 col-md-1 order-price">
                                                                {{ (detail.product.product_sku) ? detail.product.product_sku : detail.product.product_barcode }}
                                                            </td>
                                                            <td class="tag-color col-12 col-md-2 order-price">
                                                                {{ parseFloat(detail.product_price_with_tax).toFixed(2) }} €
                                                            </td>
                                                            <td class="tag-color col-12 col-md-2 order-price">
                                                                {{ (detail.product_discount_price_with_tax>0)
                                                                ? parseFloat(detail.product_discount_price_with_tax).toFixed(2)
                                                                : parseFloat(detail.product_price_with_tax).toFixed(2) }} €
                                                            </td>
                                                            <td class="col-12 col-md-1">
                                                                <div class="input-group">
                                                                    {{ detail.product_qty }}
                                                                </div>
                                                            </td>
                                                            <td class="tag-s col-12 col-md-2 order-sub-price">
                                                                {{ parseFloat(detail.product_discount_price_with_tax*detail.product_qty ).toFixed(2) }} €
                                                            </td>
                                                        </tr>
                                                        <tr class="d-flex responsive-lay">
                                                            <td class="col-12 col-md-2 item-detail-left"></td>
                                                            <td class="tag-color col-12 col-md-1 order-price"></td>
                                                            <td class="tag-color col-12 col-md-2 order-price"></td>
                                                            <td class="tag-color col-12 col-md-2 order-price"></td>
                                                            <td class="tag-color col-12 col-md-2 order-price"></td>
                                                            <td class="col-12 col-md-1">
                                                                {{productsCount}}
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                    <div class="row justify-content-end">
                                                        <div class="col-12 col-md-4">
                                                            <div>
                                                                <table class="table right-table">
                                                                    <tbody>
                                                                    <tr class="d-flex align-items-center justify-content-between">
                                                                        <th class="border-0 font-size-h5 mb-0 font-size-bold text-dark">
                                                                            Промежуточная сумма
                                                                        </th>
                                                                        <td class="border-0 justify-content-end d-flex text-black-50 font-size-base">
                                                                            {{ parseFloat(subtotal).toFixed(2) }} €
                                                                        </td>
                                                                    </tr>
                                                                    <tr class="d-flex align-items-center justify-content-between">
                                                                        <th class="border-0 font-size-h5 mb-0 font-size-bold text-dark">
                                                                            Скидка
                                                                        </th>
                                                                        <td class="border-0 justify-content-end d-flex text-black-50 font-size-base">
                                                                            {{ discountTotal }} €
                                                                        </td>
                                                                    </tr>
                                                                    <tr class="d-flex align-items-center justify-content-between"
                                                                        v-for="line in vatBreakdown" :key="'vat'+line.rate">
                                                                        <th class="border-0 font-size-h5 mb-0 font-size-bold text-dark">
                                                                            НДС {{ line.rate }}%
                                                                        </th>
                                                                        <td class="border-0 justify-content-end d-flex text-black-50 font-size-base">
                                                                            {{ line.amount.toFixed(2) }} €
                                                                        </td>
                                                                    </tr>
                                                                    <tr class="d-flex align-items-center justify-content-between" v-if="!vatBreakdown.length">
                                                                        <th class="border-0 font-size-h5 mb-0 font-size-bold text-dark">
                                                                            Налог
                                                                        </th>
                                                                        <td class="border-0 justify-content-end d-flex text-black-50 font-size-base">
                                                                            {{ parseFloat(tax_total).toFixed(2) }} €
                                                                        </td>
                                                                    </tr>
                                                                    <tr class="d-flex align-items-center justify-content-between">
                                                                        <th class="border-0 font-size-h5 mb-0 font-size-bold text-dark">
                                                                           Доставка без НДС
                                                                        </th>
                                                                        <td class="border-0 justify-content-end d-flex text-black-50 font-size-base">
                                                                            {{ shippingWithoutVat }} €
                                                                        </td>
                                                                    </tr>
                                                                    <tr v-if="coupon_amount > 0" class="d-flex align-items-center justify-content-between">
                                                                        <th class="border-0 font-size-h5 mb-0 font-size-bold text-dark">
                                                                            Скидка по купону
                                                                        </th>
                                                                        <td class="border-0 justify-content-end d-flex text-black-50 font-size-base">
                                                                            -{{ parseFloat(coupon_amount).toFixed(2) }} €
                                                                        </td>
                                                                    </tr>
                                                                    <tr class="d-flex align-items-center justify-content-between">
                                                                        <th class="border-0 font-size-h5 mb-0 font-size-bold text-dark">
                                                                            Итого
                                                                        </th>
                                                                        <td class="border-0 justify-content-end d-flex text-black-50 font-size-base">
                                                                            {{ parseFloat(total).toFixed(2) }} €
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <Offer v-if="type=='offer'" :editable="false"></Offer>
                                        <Total v-if="type=='offer'" :totals="offer_totals"></Total>
                                        <div
                                            v-if="!processed && editMode" class="col-md-12 d-flex justify-content-end">
                                            <button class="btn btn-primary" @click="saveOrder()">
                                                Сохранить
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="tab-pane fade"
                                    id="invoice"
                                    role="tabpanel"
                                    aria-labelledby="invoice-tab"
                                >
                                    <div class="card card-custom gutter-b bg-white border-0">
                                        <div
                                            class="
                        card-header
                        d-flex
                        align-items-start
                        justify-content-between
                        border-0
                        pb-5
                      "
                                        >
                                            <div class="card-title mb-0 d-flex inovice-main">
                                                <div
                                                    class="bg-primary pb-3 h-150px w-150px d-flex flex-column justify-content-end align-items-center">
                                                    <h3 class="font-size-h3 text-white">Invoice</h3>
                                                    <h4 class="font-size-h4 text-white">
                                                        {{ orders.order_id }}
                                                    </h4>
                                                </div>
                                                <div class="card-user-detail padding-top pl-3 w-250px">

                                                    <h5 class="font-size-h5 text-dark">
                                                        {{ getCustomerFullName(orders.customer) }}
                                                    </h5>
                                                    <h5 class="font-size-h5 text-dark">
                                                        {{ orders.customer.customer_email }}
                                                    </h5>
                                                    <h5 class="font-size-h5 text-dark">
                                                        {{ orders.delivery_street_address }}
                                                    </h5>
                                                    <h5 class="font-size-h5 text-dark">
                                                        {{ orders.delivery_phone }}
                                                    </h5>

                                                </div>
                                            </div>

                                            <div class="padding-top">
                                                <h5 class="font-size-h5 text-black-50">
                                                    Дата <span>{{ orders.order_date }}</span>
                                                </h5>
                                                <hr />
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-12 table-padding">
                                                    <table class="table table-striped text-body">
                                                        <thead>
                                                            <tr class="d-flex">
                                                                <th class="col-2"></th>
                                                                <th class="col-3">Продукт</th>
                                                                <th class="col-2">Цена</th>
                                                                <th class="col-2">Цена со скидкой aaa</th>
                                                                <th class="col-1">Кол-во</th>
                                                                <th class="col-2">Сумма</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody id="order-show-detail">
                                                        <tr
                                                            class="d-flex responsive-lay"
                                                            v-for="detail in orders.order_detail"
                                                            v-if="detail.product.product_type == 'variable'"
                                                        >
                                                            <td class="col-12 col-md-3 item-detail-left">
                                                                <div class="text-body">
                                                                    <h6 class="order-product-name">
                                                                        {{ detail.product.product_title }}
                                                                        <span v-if="detail.is_gift" class="badge badge-success ml-1">Подарок</span>
                                                                        <span
                                                                            v-for="variation in detail.product_combination.combination"
                                                                            :key="variation.variation_id"
                                                                        >
                                                                            {{ getVariationName(variation) }}
                                                                        </span>
                                                                    </h6>
                                                                </div>
                                                            </td>
                                                            <td class="tag-color col-12 col-md-2 order-price">
                                                                {{ detail.product_price }} €
                                                            </td>
                                                            <td class="tag-color col-12 col-md-2 order-price">
                                                                {{ (detail.product_discount>0)?detail.product_discount:"-" }} €
                                                            </td>
                                                            <td class="col-12 col-md-1">
                                                                <div class="input-group">{{ detail.product_qty }}</div>
                                                            </td>
                                                            <td class="tag-s col-12 col-md-2 order-sub-price">{{ parseFloat(detail.product_total * detail.product_qty).toFixed(2) }}</td>
                                                        </tr>

                                                        <tr
                                                            class="d-flex responsive-lay"
                                                            v-for="detail in orders.order_detail"
                                                            v-if="detail.product.product_type == 'simple'"
                                                        >
                                                            <td class="col-12 col-md-3 item-detail-left">
                                                                <div class="text-body">
                                                                    <h6 class="order-product-name">
                                                                        {{ detail.product.product_title }}
                                                                        <span v-if="detail.is_gift" class="badge badge-success ml-1">Подарок</span>
                                                                    </h6>
                                                                </div>
                                                            </td>
                                                            <td
                                                                class="tag-color col-12 col-md-2 order-price"
                                                            >
                                                                {{ detail.product_price }} €
                                                            </td>
                                                            <td
                                                                class="tag-color col-12 col-md-2 order-price"
                                                            >
                                                                {{ (detail.product_discount>0)?detail.product_discount:"-" }} €
                                                            </td>
                                                            <td class="col-12 col-md-1">
                                                                <div class="input-group">
                                                                    {{ detail.product_qty }}
                                                                </div>
                                                            </td>
                                                            <td
                                                                class="tag-s col-12 col-md-2 order-sub-price"
                                                            >
                                                                {{ parseFloat(detail.product_total * detail.product_qty).toFixed(2) }} €
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                    <div class="row justify-content-end">
                                                        <div class="col-12 col-md-3">
                                                            <div>
                                                                <table class="table right-table">
                                                                    <tbody>
                                                                    <tr
                                                                        class="
                                        d-flex
                                        align-items-center
                                        justify-content-between
                                      "
                                                                    >
                                                                        <th
                                                                            class="
                                          border-0
                                          font-size-h5
                                          mb-0
                                          font-size-bold
                                          text-dark
                                        "
                                                                        >
                                                                            SUBTOTAL
                                                                        </th>
                                                                        <td
                                                                            class="
                                          border-0
                                          justify-content-end
                                          d-flex
                                          text-black-50
                                          font-size-base
                                        "
                                                                        >
                                                                            {{ subtotal }} €
                                                                        </td>
                                                                    </tr>
                                                                    <tr
                                                                        class="
                                        d-flex
                                        align-items-center
                                        justify-content-between
                                      "
                                                                    >
                                                                        <th
                                                                            class="
                                          border-0
                                          font-size-h5
                                          mb-0
                                          font-size-bold
                                          text-dark
                                        "
                                                                        >
                                                                            DISCOUNT
                                                                        </th>
                                                                        <td
                                                                            class="
                                          border-0
                                          justify-content-end
                                          d-flex
                                          text-black-50
                                          font-size-base
                                        "
                                                                        >
                                                                            {{ discountTotal }} €
                                                                        </td>
                                                                    </tr>
                                                                    <tr
                                                                        class="
                                        d-flex
                                        align-items-center
                                        justify-content-between
                                      "
                                                                    >
                                                                        <th
                                                                            class="
                                          border-0
                                          font-size-h5
                                          mb-0
                                          font-size-bold
                                          text-dark
                                        "
                                                                        >
                                                                            TAX
                                                                        </th>
                                                                        <td
                                                                            class="
                                          border-0
                                          justify-content-end
                                          d-flex
                                          text-black-50
                                          font-size-base
                                        "
                                                                        >
                                                                            {{ tax_total }} €
                                                                        </td>
                                                                    </tr>
                                                                    <tr
                                                                        class="
                                        d-flex
                                        align-items-center
                                        justify-content-between
                                      "
                                                                    >
                                                                        <th
                                                                            class="
                                          border-0
                                          font-size-h5
                                          mb-0
                                          font-size-bold
                                          text-dark
                                        "
                                                                        >
                                                                            SHIPPING
                                                                        </th>
                                                                        <td
                                                                            class="
                                          border-0
                                          justify-content-end
                                          d-flex
                                          text-black-50
                                          font-size-base
                                        "
                                                                        >
                                                                            {{ shipping_cost }} €
                                                                        </td>
                                                                    </tr>
                                                                    <tr
                                                                        v-if="coupon_amount > 0"
                                                                        class="
                                        d-flex
                                        align-items-center
                                        justify-content-between
                                      "
                                                                    >
                                                                        <th
                                                                            class="
                                          border-0
                                          font-size-h5
                                          mb-0
                                          font-size-bold
                                          text-dark
                                        "
                                                                        >
                                                                            COUPON
                                                                        </th>
                                                                        <td
                                                                            class="
                                          border-0
                                          justify-content-end
                                          d-flex
                                          text-black-50
                                          font-size-base
                                        "
                                                                        >
                                                                            -{{ parseFloat(coupon_amount).toFixed(2) }} €
                                                                        </td>
                                                                    </tr>
                                                                    <tr
                                                                        class="
                                        d-flex
                                        align-items-center
                                        justify-content-between
                                        item-price
                                      "
                                                                    >
                                                                        <th
                                                                            class="
                                          border-0
                                          font-size-h5
                                          mb-0
                                          font-size-bold
                                          text-dark
                                        "
                                                                        >
                                                                            TOTAL
                                                                        </th>
                                                                        <td
                                                                            class="
                                          border-0
                                          justify-content-end
                                          d-flex
                                          text-dark
                                          font-size-base
                                        "
                                                                        >
                                                                            {{ total }} €
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="tab-pane fade status-tab-style"
                                    id="status"
                                    role="tabpanel"
                                    aria-labelledby="status-tab"
                                >
                                    <div class="card card-custom gutter-b bg-white border-0">
                                        <div class="card-body">
                                            <div class="row gutter-b">
                                                <div class="col-12 table-padding">
                                                    <table class="table table-striped text-body">
                                                        <thead>
                                                        <tr class="row">
                                                            <th
                                                                class="text-center border-0 col-6"
                                                                scope="col"
                                                            >
                                                                DATE ADDED
                                                            </th>
                                                            <th
                                                                class="text-center border-0 col-6"
                                                                scope="col"
                                                            >
                                                                STATUS
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr class="row" v-for="history in orders.order_history">
                                                            <td class="text-center col-6">
                                                                {{history.created_at}}
                                                            </td>
                                                            <td class="text-center col-6">
                                                                {{history.order_status}}
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <div
                                                        class="
                              form-group
                              row
                              align-items-center
                              justify-content-center
                            "
                                                    >
                                                        <div class="col-xl-6 col-lg-8 col-12 status-detail">
                                                            <label class="col-form-label mr-3"
                                                            >Order Status</label
                                                            >
                                                            <fieldset class="form-group">
                                                                <select

                                                                    class="form-control"
                                                                    v-model="order_status"
                                                                    v-if="order_status == 'Pending'"
                                                                >
                                                                    <option
                                                                        value="Pending"
                                                                        :selected="
                                      order_status == 'Pending'
                                        ? 'selected'
                                        : ''
                                    "
                                                                    >

                                                                        Pending
                                                                    </option>

                                                                    <option
                                                                        value="Inprocess"
                                                                        :selected="
                                      order_status == 'Inprocess'
                                        ? 'selected'
                                        : ''
                                    "
                                                                    >

                                                                        In Process
                                                                    </option>

                                                                    <option
                                                                        value="Dispatched"
                                                                        :selected="
                                      order_status == 'Dispatched'
                                        ? 'selected'
                                        : ''
                                    "
                                                                    >

                                                                        Dispatched
                                                                    </option>
                                                                    <option
                                                                        value="Complete"
                                                                        :selected="
                                      order_status == 'Complete'
                                        ? 'selected'
                                        : ''
                                    "
                                                                    >
                                                                        Complete
                                                                    </option>
                                                                    <option
                                                                        value="Return"
                                                                        :selected="
                                      order_status == 'Return' ? 'selected' : ''
                                    "
                                                                    >
                                                                        Return
                                                                    </option>
                                                                    <option
                                                                        value="Cancel"
                                                                        :selected="
                                      order_status == 'Cancel' ? 'selected' : ''
                                    "
                                                                    >
                                                                        Cancel
                                                                    </option>
                                                                </select>


                                                                <select

                                                                    class="form-control"
                                                                    v-model="order_status"
                                                                    v-if="order_status == 'Inprocess'"
                                                                >
                                                                    <option
                                                                        value="Inprocess"
                                                                        :selected="
                                      order_status == 'Inprocess'
                                        ? 'selected'
                                        : ''
                                    "
                                                                    >

                                                                        In Process
                                                                    </option>

                                                                    <option
                                                                        value="Dispatched"
                                                                        :selected="
                                      order_status == 'Dispatched'
                                        ? 'selected'
                                        : ''
                                    "
                                                                    >

                                                                        Dispatched
                                                                    </option>
                                                                    <option
                                                                        value="Complete"
                                                                        :selected="
                                      order_status == 'Complete'
                                        ? 'selected'
                                        : ''
                                    "
                                                                    >
                                                                        Complete
                                                                    </option>
                                                                    <option
                                                                        value="Return"
                                                                        :selected="
                                      order_status == 'Return' ? 'selected' : ''
                                    "
                                                                    >
                                                                        Return
                                                                    </option>
                                                                    <option
                                                                        value="Cancel"
                                                                        :selected="
                                      order_status == 'Cancel' ? 'selected' : ''
                                    "
                                                                    >
                                                                        Cancel
                                                                    </option>
                                                                </select>

                                                                <select

                                                                    class="form-control"
                                                                    v-model="order_status"
                                                                    v-if="order_status == 'Dispatched'"
                                                                >

                                                                    <option
                                                                        value="Dispatched"
                                                                        :selected="
                                      order_status == 'Dispatched'
                                        ? 'selected'
                                        : ''
                                    "
                                                                    >

                                                                        Dispatched
                                                                    </option>
                                                                    <option
                                                                        value="Complete"
                                                                        :selected="
                                      order_status == 'Complete'
                                        ? 'selected'
                                        : ''
                                    "
                                                                    >
                                                                        Complete
                                                                    </option>
                                                                    <option
                                                                        value="Return"
                                                                        :selected="
                                      order_status == 'Return' ? 'selected' : ''
                                    "
                                                                    >
                                                                        Return
                                                                    </option>
                                                                    <option
                                                                        value="Cancel"
                                                                        :selected="
                                      order_status == 'Cancel' ? 'selected' : ''
                                    "
                                                                    >
                                                                        Cancel
                                                                    </option>
                                                                </select>

                                                                <select

                                                                    class="form-control"
                                                                    v-model="order_status"
                                                                    v-if="order_status == 'Complete'"
                                                                >
                                                                    <option
                                                                        value="Complete"
                                                                        :selected="
                                      order_status == 'Complete'
                                        ? 'selected'
                                        : ''
                                    "
                                                                    >
                                                                        Complete
                                                                    </option>
                                                                    <option
                                                                        value="Return"
                                                                        :selected="
                                      order_status == 'Return' ? 'selected' : ''
                                    "
                                                                    >
                                                                        Return
                                                                    </option>
                                                                </select>

                                                                <select

                                                                    class="form-control"
                                                                    v-model="order_status"
                                                                    v-if="order_status == 'Cancel'"
                                                                >
                                                                    <option
                                                                        value="Cancel"
                                                                        :selected="
                                      order_status == 'Cancel' ? 'selected' : ''
                                    "
                                                                    >
                                                                        Cancel
                                                                    </option>
                                                                </select>

                                                                <select

                                                                    class="form-control"
                                                                    v-model="order_status"
                                                                    v-if="order_status == 'Return'"
                                                                >
                                                                    <option
                                                                        value="Return"
                                                                        :selected="
                                      order_status == 'Return' ? 'selected' : ''
                                    "
                                                                    >
                                                                        Return
                                                                    </option>
                                                                </select>
                                                                <br />

                                                                <button class="btn btn-primary" id="subbutton" style="float:right"
                                                                        v-if="db_order_status != 'Cancel' && db_order_status != 'Return'"
                                                                        @click="statusUpdate()
                          ">Submit</button>
                                                            </fieldset>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="tab-pane fade"
                                    id="delivery"
                                    role="tabpanel"
                                    aria-labelledby="delivery-tab"
                                    v-if="setting.is_deliveryboyapp_purchased === '1'"
                                >
                                    <div class="row">
                                        <div class="col-lg-12 col-12">
                                            <div class="card card-custom gutter-b bg-white border-0">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <div
                                                                class="
                              form-group
                              row
                              align-items-center
                              justify-content-center
                            "
                                                            >
                                                                <div class="col-xl-6 col-lg-8 col-12 status-detail">
                                                                    <label class="col-form-label mr-3"
                                                                    >Assign Order To Delivery Boy</label
                                                                    >
                                                                    <fieldset class="form-group">

                                                                        <select

                                                                            class="form-control"
                                                                            v-model="delivery_boy_id"
                                                                        >
                                                                            <option
                                                                                v-for="db in deliveryboys"
                                                                                :selected = "orders.delivery_boy_id == db.id"
                                                                                :value="db.id"
                                                                            >
                                                                                {{ db.first_name }} {{ db.last_name }}
                                                                            </option>
                                                                        </select>
                                                                        <br />

                                                                        <button class="btn btn-primary" style="float:right" @click="assignDeliveryBoy()">Submit</button>
                                                                    </fieldset>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="tab-pane fade"
                                    id="notes"
                                    role="tabpanel"
                                    aria-labelledby="notes-tab"
                                >
                                    <div class="card card-custom gutter-b bg-white border-0">
                                        <div class="card-body">
                                            <div id="draggable-cards" class="gutter-t">
                                                <div class="row" id="card-drag-area">
                                                    <div class="col-lg-6 col-xl-4" v-for="note in orders.order_notes">
                                                        <div
                                                            id="02"
                                                            class="
                                card card-custom
                                gutter-b
                                bg-white
                                border-0
                                pincard
                              "
                                                        >
                                                            <div
                                                                class="card-header align-items-center border-0"
                                                            >
                                                                <div class="card-title mb-0">
                                                                    <h5 class="font-size-h5 text-black-50">
                                                                        {{ note.created_at }}
                                                                    </h5>
                                                                </div>

                                                                <div class="pin-click" id="pin2">
                                                                    <!-- <i
                                                                      class="
                                                                        fas
                                                                        fa-eye-slash
                                                                        pin-fixnot
                                                                        dis-block
                                                                      "
                                                                    ></i>
                                                                    <i class="fas fa-eye pin dis-none"></i> -->
                                                                </div>
                                                            </div>
                                                            <div class="card-body">
                                                                <div class="card-title mb-0">
                                                                    <h3 class="font-size-h3 text-body">
                                                                        {{ note.title }}
                                                                    </h3>
                                                                </div>
                                                                <div class="card-detail text-dark">
                                                                    <p>
                                                                        {{ note.notes }}

                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-6 col-xl-4">
                                                        <div
                                                            class="
                                border-dashed
                                addnote
                                pincard
                                d-flex
                                justify-content-center
                                align-items-center
                              "
                                                        >
                                                            <div class="card-toolbar" @click="display_form = !display_form">
                                                                <div
                                                                    class="
                                    btn btn-icon btn-secondary btn-plus
                                    h-100px
                                    w-100px
                                  "
                                                                    id="kt_notes_panel_toggle"
                                                                    data-toggle="tooltip"
                                                                    title=""
                                                                    data-placement="right"
                                                                    data-original-title="Check out more demos"
                                                                >
                                  <span
                                      class="
                                      svg-icon svg-icon-xl svg-icon-primary
                                      white
                                    "
                                  >
                                    <svg
                                        width=""
                                        height=""
                                        viewBox="0 0 16 16"
                                        class="bi bi-plus"
                                        fill="currentColor"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                          fill-rule="evenodd"
                                          d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                                      ></path>
                                    </svg>
                                  </span>
                                                                    <h5 class="mt-3 text-dark font-size-h5">
                                                                        Add Notes
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div
                                    class="tab-pane fade"
                                    id="message"
                                    role="tabpanel"
                                    aria-labelledby="message-tab"
                                >
                                    <div class="row">
                                        <div class="col-12">
                                            <div
                                                class="
                          card card-custom
                          gutter-b
                          bg-white
                          border-0
                          message-content
                          p-5
                        "
                                            >
                                                <div class="row justify-content-center">
                                                    <div class="col-12 col-md-8">
                                                        <div
                                                            class="
                                d-flex
                                align-items-center
                                border-0
                                p-3
                                rounded
                                mb-5
                              "
                                                            v-for="comment in orders.order_comments"
                                                        >
                                                            <div class="media">

                                                                <div class="media-body ml-3" v-if="comment.customer != null">
                                                                    <div
                                                                        class="d-flex justify-content-between mb-1"
                                                                    >
                                                                        <h3 class="font-size-h3 text-dark info-tag">
                                                                            {{ comment.customer.customer_first_name }} {{ comment.customer.customer_last_name }}
                                                                        </h3>
                                                                    </div>
                                                                    <div
                                                                        class="
                                      badge badge-primary
                                      font-size-h5
                                      rounded
                                    "
                                                                    >
                                                                        Customer
                                                                    </div>
                                                                </div>
                                                                <div class="media-body ml-3" v-if="comment.user != null">
                                                                    <div
                                                                        class="d-flex justify-content-between mb-1"
                                                                    >
                                                                        <h3 class="font-size-h3 text-dark info-tag">
                                                                            {{ comment.user.name }}
                                                                        </h3>
                                                                    </div>
                                                                    <div
                                                                        class="
                                      badge badge-primary
                                      font-size-h5
                                      rounded
                                    "
                                                                    >
                                                                        {{ getCommentRoleName(comment) }}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="text-input position-relative disabled"
                                                            >
                                                                <div class="date-text">
                                                                    <h5
                                                                        class="
                                      font-size-h5
                                      text-black-50 text-right
                                    "
                                                                    >
                                                                        {{ comment.created_at }}
                                                                    </h5>
                                                                </div>
                                                                <fieldset class="form-label-group">
                                  <textarea
                                      class="form-control fixed-size"
                                      id="horizontalTextarea1"
                                      rows="6"
                                      :placeholder="comment.message"
                                      disabled
                                  ></textarea>
                                                                </fieldset>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row justify-content-center">
                                                    <div class="col-12 col-md-8">
                                                        <div class="card-header align-items-end border-0 rounded position-relative">
                                                            <fieldset class="form-label-group w-100">
                                <textarea
                                    id="txtarea"
                                    class="
                                    bg-light
                                    autoexpand-textarea
                                    form-control
                                  "
                                    placeholder=" Enter Text.."
                                    v-model="message"
                                ></textarea>
                                                                <small class="form-text text-danger" v-if="errors.has('message')" v-text="errors.get('message')"></small>


                                                            </fieldset>
                                                            <div class="addclip-input pr-3 pb-2">
                                                                <button class="btn btn-primary" @click="saveComments()">Send</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Stock Warning Modal -->
        <div v-if="showStockModal" class="modal-backdrop fade show"></div>
        <div v-if="showStockModal" class="modal fade show" style="display: block;" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Недостаточно товара на складе
                        </h5>
                        <button type="button" class="close" @click="closeStockModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="font-weight-bold">Следующие товары имеют недостаточное количество на складе:</p>
                        <table class="table table-bordered table-sm">
                            <thead class="thead-light">
                                <tr>
                                    <th>Товар</th>
                                    <th class="text-center">Требуется</th>
                                    <th class="text-center">В наличии</th>
                                    <th class="text-center">Нехватка</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in stockDeficientItems" :key="item.product_id">
                                    <td>{{ item.product_name }}</td>
                                    <td class="text-center">{{ item.required_qty }}</td>
                                    <td class="text-center">{{ item.available_qty }}</td>
                                    <td class="text-center font-weight-bold">-{{ item.shortage }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="mt-3">Вы уверены, что хотите провести заказ несмотря на нехватку товара?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-dark" @click="closeStockModal">Отмена</button>
                        <button type="button" class="btn btn-primary" @click="forceProcess">
                            Провести все равно
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div id="kt_notes_panel" class="offcanvas offcanvas-right kt-color-panel p-5 offcanvas-on" v-if="display_form == 1">
            <div class="offcanvas-header d-flex align-items-center justify-content-between pb-3">
                <h4 class="font-size-h4 font-weight-bold m-0">Add Note
                </h4>
                <a href="#" class="btn btn-sm btn-icon btn-light btn-hover-primary" id="kt_notes_panel_close" @click="display_form = !display_form">
                    <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                    </svg>
                </a>
            </div>
            <form id="myform" novalidate="novalidate">
                <div class="form-group">
                    <label class="text-dark" for="exampleInputText1">Title of a Note</label>
                    <input type="text" name="text" class="form-control" id="exampleInputText1" aria-describedby="textHelp" v-model="notes_title">
                    <small class="form-text text-danger" v-if="errors.has('title')" v-text="errors.get('title')"></small>

                </div>
                <div class="form-group">
                    <label class="text-dark">Note</label>
                    <textarea class="form-control" id="label-textarea2" rows="6" placeholder="Write A Text" v-model="notes"></textarea>
                    <small class="form-text text-danger" v-if="errors.has('notes')" v-text="errors.get('notes')"></small>

                </div>
                <button type="button" class="btn btn-primary" @click="saveNotes()">Add Note</button>
            </form>
        </div>
    </div>

        <activity-log-modal
            ref="activityLogModal"
            model-type="order"
            :model-id="$route.params.id"
        />
    </div>
</template>
<script>
import ErrorHandling from "../../ErrorHandling";
import Offer from "./Offer";
import ActivityLogModal from "./ActivityLogModal.vue";
import Total from "./Total";

const createEmptyOrder = () => ({
    order_id: "",
    opencart_id: "",
    order_price: 0,
    order_date_formatted: "",
    payment_method: "",
    shipping_cost: 0,
    shipping_option_detail: null,
    shipping_method_detail: null,
    tracking: "",
    internal_note: "",
    bill_note: "",
    processed: false,
    processed_at: "",
    type: "order",
    customer: {
        customer_email: "",
        customer_first_name: "",
        customer_last_name: "",
        customer_tax_number: "",
        customer_is_legal_person: false,
    },
    order_status: {
        id: null,
        detail: [],
    },
    order_detail: [],
    order_comments: [],
    billing_country1: null,
    billing_state1: null,
    delivery_country1: null,
    delivery_state1: null,
});

const getNameFromDetails = (details) => {
    if (!Array.isArray(details)) {
        return "";
    }

    const detailWithName = details.find((item) => item && item.name);

    return detailWithName ? detailWithName.name : "";
};

const normalizeComment = (comment = {}) => ({
    ...comment,
    user: comment.user || null,
});

const normalizeOrderDetail = (detail = {}) => ({
    ...detail,
    product: detail.product || {},
    product_combination: {
        combination: [],
        ...(detail.product_combination || {}),
    },
});

const normalizeOrder = (order = {}) => ({
    ...createEmptyOrder(),
    ...order,
    customer: {
        ...createEmptyOrder().customer,
        ...(order.customer || {}),
    },
    order_status: {
        ...createEmptyOrder().order_status,
        ...(order.order_status || {}),
    },
    order_detail: Array.isArray(order.order_detail)
        ? order.order_detail.map((detail) => normalizeOrderDetail(detail))
        : [],
    order_comments: Array.isArray(order.order_comments)
        ? order.order_comments.map((comment) => normalizeComment(comment))
        : [],
});

export default {
    components: {Offer, Total, ActivityLogModal},
    data() {
        return {
            type: 'order',
            offer_totals: [],
            display_form: 0,
            orders: createEmptyOrder(),
            order_statuses: [],
            searchParameter: "",
            sortBy: "id",
            sortType: "ASC",
            limit: 10,
            message:'',
            error_message: "",
            edit: false,
            actions: false,
            pagination: {},
            request_method: "",
            is_default: "0",
            order_status: "",
            order_status_id: 0,
            db_order_status: "",
            token: [],
            subtotal: 0.00,
            tax_total: 0.00,
            vatBreakdown: [],
            shippingWithoutVat: "0.00",
            shipping_cost: 0.00,
            discountTotal: 0.00,
            coupon_amount: 0.00,
            coupon_code: null,
            total: 0.00,
            notes_title:"",
            notes:"",
            setting: {},
            errors: new ErrorHandling(),
            csrf: document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content"),
            processed: false,
            processed_at: '',
            editMode: false,
            stockDeficientItems: [],
            showStockModal: false,
        };
    },

    computed: {
        productsCount(){
            return this.orders.order_detail.reduce((total, product) => {
                return total + Number(product.product_qty);
            }, 0);
        }
    },

    methods: {
        getOrderStatusName(orderStatus) {
            if (!orderStatus) {
                return "";
            }

            return getNameFromDetails(orderStatus.detail);
        },
        getVariationName(variation) {
            if (!variation || !variation.variation) {
                return "";
            }

            return getNameFromDetails(variation.variation.detail);
        },
        getCustomerFullName(customer) {
            if (!customer) {
                return "";
            }

            return [customer.customer_first_name, customer.customer_last_name]
                .filter(Boolean)
                .join(" ");
        },
        getCommentRoleName(comment) {
            if (!comment || !comment.user || !comment.user.role) {
                return "";
            }

            return comment.user.role.name || "";
        },
        fetchorders(page_url) {
            this.$parent.loading = true;
            let vm = this;
            page_url =
                page_url ||
                "/api/admin/order/" +
                this.$route.params.id +
                "?orderDetail=1&productDetail=1&currency=1&billing_country=1&billing_state=1&delivery_country=1&delivery_state=1&customer=1";

            axios
                .get(page_url, this.token)
                .then((res) => {
                    const orderData = normalizeOrder(res.data.data);

                    this.orders = orderData;
                    this.processed = orderData.processed;
                    this.processed_at = orderData.processed_at ? orderData.processed_at.substring(0, 10) : '';
                    this.order_status = this.orders.order_status;
                    this.order_status_id = this.orders.order_status ? this.orders.order_status.id : 0;
                    this.db_order_status = this.orders.order_status;
                    this.shipping_cost = Number(this.orders.shipping_cost || 0);

                    // Every line was divided by 1.21 whatever rate it carried, so
                    // an order with a line at 0% showed tax that was never
                    // charged. Each line is taxed at its own rate, the way it was
                    // saved and the way the invoice prints it.
                    let sub_total = parseFloat(0);
                    let tax_total = parseFloat(0);
                    let total_discount = 0;
                    const vatByRate = {};

                    for (var i = 0; i < this.orders.order_detail.length; i++) {
                        const line = this.orders.order_detail[i];
                        const rate = Number(line.product_tax_rate) || 0;
                        const divisor = 1 + rate / 100;
                        const qty = Number(line.product_qty) || 0;
                        const gross = Number(line.product_discount_price_with_tax || 0) * qty;
                        const vat = gross - gross / divisor;

                        if (Number(line.product_price_with_tax) > Number(line.product_discount_price_with_tax)) {
                            total_discount += (Number(line.product_price_with_tax) - Number(line.product_discount_price_with_tax)) * qty / divisor;
                        }

                        sub_total += gross / divisor;
                        tax_total += vat;

                        if (vat > 0) {
                            vatByRate[rate] = (vatByRate[rate] || 0) + vat;
                        }
                    }

                    // Delivery is taxed at the highest rate in the order, which is
                    // what the order stored and what the invoice charges.
                    const rates = Object.keys(vatByRate).map(Number);
                    const topRate = rates.length ? Math.max.apply(null, rates) : 0;
                    let shippingVat = 0;

                    if (this.shipping_cost > 0 && topRate > 0) {
                        shippingVat = this.shipping_cost - this.shipping_cost / (1 + topRate / 100);
                        vatByRate[topRate] += shippingVat;
                        tax_total += shippingVat;
                    }

                    this.shippingWithoutVat = (this.shipping_cost - shippingVat).toFixed(2);
                    this.vatBreakdown = Object.keys(vatByRate)
                        .map(rate => ({ rate: Number(rate), amount: Number(vatByRate[rate].toFixed(2)) }))
                        .filter(line => line.amount > 0)
                        .sort((a, b) => b.rate - a.rate);
                    this.discountTotal = Number(total_discount).toFixed(2);
                    this.subtotal = parseFloat(sub_total).toFixed(2);

                    this.total = parseFloat(this.orders.order_price).toFixed(2);

                    if(this.orders.billing_country1 && this.orders.billing_country1.country_name != 'Latvia' && this.orders.customer.customer_tax_number && this.orders.customer.customer_is_legal_person){
                        this.tax_total = 0;
                        this.discountTotal = 0;
                        this.vatBreakdown = [];
                        this.shippingWithoutVat = Number(this.shipping_cost).toFixed(2);
                        this.subtotal =  parseFloat(this.total - this.shipping_cost).toFixed(2);
                    }else{
                        this.tax_total = parseFloat(tax_total).toFixed(2);
                    }

                    this.coupon_amount = (this.orders.coupon_amount != null && this.orders.coupon_amount != 'null' && this.orders.coupon_amount != '') ? Number(this.orders.coupon_amount) : 0;
                    this.coupon_code = this.orders.coupon_code || null;
                    if(orderData.type == 'offer'){
                        this.type = 'offer';
                        this.$store.dispatch('offer/fetchProducts', orderData.order_id);
                        this.offer_totals = {
                            'Итого' : this.total
                        };
                    }

                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchOrderStatuses() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/order-status", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.order_statuses = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        statusUpdate(id) {
            this.$parent.loading = true;
            let vm = this;
            var page_url = "/api/admin/order/" + this.$route.params.id + "/status-update";

            axios
                .post(page_url, { order_status_id: id }, this.token)
                .then((res) => {
                    this.$toaster.success("Order status updated");
                })
                .finally(() => (this.$parent.loading = false));
        },
        saveNotes() {
            this.$parent.loading = true;
            let vm = this;
            var page_url = "/api/admin/add_notes";
            let data = {
                notes:this.notes,
                title:this.notes_title,
                id:this.$route.params.id
            }
            axios
                .post(page_url, data, this.token)
                .then((res) => {
                    this.fetchorders();
                    this.$toaster.success("Order Note added");
                    this.notes_title = '';
                    this.notes = '';
                    this.display_form = 0;
                })
                .catch(error => {
                    this.error_message = '';
                    this.errors = new ErrorHandling();
                    if (error.response.status == 422) {
                        if(error.response.data.status == 'Error'){orders
                            this.error_message = error.response.data.message;
                        }
                        else{
                            this.errors.record(error.response.data.errors);
                        }
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        saveComments() {
            this.$parent.loading = true;
            let vm = this;
            var page_url = "/api/admin/add_comments";
            let data = {
                message:this.message,
                id:this.$route.params.id
            }
            axios
                .post(page_url, data, this.token)
                .then((res) => {
                    this.fetchorders();
                    this.$toaster.success("Order Comments added");
                    this.message = '';
                })
                .catch(error => {
                    this.error_message = '';
                    this.errors = new ErrorHandling();
                    if (error.response.status == 422) {
                        if(error.response.data.status == 'Error'){
                            this.error_message = error.response.data.message;
                        }
                        else{
                            this.errors.record(error.response.data.errors);
                        }
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchSetting() {
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};
            axios
                .get("/api/admin/setting?type=is_purchased_setting", config)
                .then((res) => {
                    for (var i = 0; i < res.data.data.length; i++) {
                        Object.assign(responseData, {
                            [res.data.data[i].setting_key]: res.data.data[i].setting_value,
                        });
                    }
                    this.setting = responseData;
                })
                .finally(() => console.log("working"));
        },
        downloadInvoice () {
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: 'blob'
            };
            axios.get("/api/admin/order/"+this.$route.params.id+"/invoice?processed_at="+this.processed_at, config)
                .then(response => {

                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = 'PPR-'+this.orders.order_id
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(console.error)
        },
        updatePaymentDueDate() {
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            };
            axios.post("/api/admin/order/" + this.$route.params.id + "/payment-due-date", { payment_due_date: this.orders.payment_due_date }, config)
                .then((res) => {
                    this.$toaster.success("Payment due date updated");
                })
                .catch((err) => {
                    this.$toaster.error("Error updating payment due date");
                    console.error(err);
                });
        },
        generateOmniva () {
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            };
            axios.post("/api/admin/order/"+this.$route.params.id+"/shipment", {}, this.token)
                .then((res) => {
                    console.log(res.data);
                    this.orders.tracking = res.data.data.tracking;
                }).catch(console.error)
        },
        generateCMR(){
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: 'blob'
            };
            axios.get("/api/admin/order/"+this.$route.params.id+"/cmr", config)
                .then(response => {

                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = 'CMR-'+this.orders.order_id
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(console.error)
        },
        downloadPartnerLabel () {
            var token = localStorage.getItem("token");
            const config = {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob'
            };

            axios.get("/api/admin/order/" + this.$route.params.id + "/label", config)
                .then(response => {
                    const blob = new Blob([response.data]);
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    // Saved under the name the partner uploaded it with, so the
                    // warehouse can tell one parcel's label from another.
                    link.download = this.orders.dropship_label_name || ('label-' + this.orders.order_id);
                    link.click();
                    URL.revokeObjectURL(link.href);
                })
                .catch(() => this.$toaster.error('Не удалось скачать наклейку'));
        },
        downloadOmnivaLabel () {
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: 'blob'
            };
            axios.get("/api/admin/order/"+this.$route.params.id+"/label", config)
                .then(response => {

                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = 'label'
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(console.error)
        },
        downloadBill () {
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: 'blob'
            };
            axios.get("/api/admin/order/"+this.$route.params.id+"/proforma-invoice", config)
                .then(response => {

                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = 'Rēķins nr '+this.orders.order_id
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(console.error)
        },
        downloadPackingList () {
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: 'blob'
            };
            axios.get("/api/admin/order/"+this.$route.params.id+"/packing-list", config)
                .then(response => {

                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = 'Packing List nr '+this.orders.order_id
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(console.error)
        },
        switchProcess(force = false){
            this.$parent.loading = true;

            const endpoint = this.processed ? 'unprocess' : 'process';
            const payload = force ? { force: true } : {};

            axios
                .post(`/api/admin/order/${this.$route.params.id}/${endpoint}`, payload, this.token)
                .then(res => {
                    this.processed = !this.processed;
                    this.$toaster.success(res.data.message);
                })
                .catch(error => {
                    if (error.response && error.response.data && error.response.data.data && error.response.data.data.stock_warning) {
                        this.stockDeficientItems = error.response.data.data.deficient_items;
                        this.openStockModal();
                    } else {
                        this.$toaster.error(error.response.data.message);
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        openStockModal() {
            this.showStockModal = true;
        },
        closeStockModal() {
            this.showStockModal = false;
            this.stockDeficientItems = [];
        },
        forceProcess() {
            this.closeStockModal();
            this.switchProcess(true);
        },
        showActivityLog() {
            this.$refs.activityLogModal.show();
        },
        editOrder() {
            this.editMode = true;
        },
        saveOrder() {
            this.editMode = false;
        }
    },
    mounted() {

        var token = localStorage.getItem("token");
        this.token = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        this.fetchOrderStatuses();
        this.fetchorders();
        this.fetchSetting();


    },
    watch: {
        // whenever question changes, this function will run
        'orders.order_status.id'(newVal, oldVal) {
            if(oldVal) {
                this.statusUpdate(newVal);
            }
        }
    },
    props: ["loading","globalSettings"],
};
</script>
